import styled from '@mui/system/styled';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material';

export const Wrapper = styled('footer')(({ theme }: { theme?: Theme }) => ({
  overflow: 'hidden',
  marginTop: '50px',
  '.footer-links-container': {
    margin: '0 auto',
    maxWidth: '95%'
  },
  '@media (min-width: 481px) ': {
    '.footer-links-container': {
      paddingLeft: '10%',
      maxWidth: 'none !important'
    }
  },
  [theme.breakpoints.up('sm')]: {
    '.footer-links-container': {
      paddingLeft: 0,
      maxWidth: '900px !important'
    }
  },
  [theme.breakpoints.up('md')]: {
    margin: '60px auto 0',
    maxWidth: '952px',
    '.footer-links-container': {
      maxWidth: 'none !important'
    },
    '.app-and-social-container': {
      position: 'relative',
      left: '8%'
    }
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: '1083px',
    '.app-and-social-container': {
      left: '2%'
    }
  }
}));

export const Copyrights = styled('div')({
  color: '#afb5c2',
  fontWeight: 300,
  fontSize: '12px',
  marginTop: '27px'
});

export const StyledGrid: any = styled(Grid)(({ theme }: { theme?: Theme }) => ({
  padding: 0,
  margin: 0,
  display: 'contents',
  [theme.breakpoints.up('md')]: {
    borderLeft: '1px solid #ebedf0',
    display: 'table-cell',
    marginLeft: '20px',
    paddingLeft: '15px',
    paddingRight: '10px'
  },
  [theme.breakpoints.up('lg')]: {
    paddingLeft: '22px'
  }
}));

export const ColumnTitle = styled('div')(({ theme }: { theme?: Theme }) => ({
  marginBottom: '15px',
  lineHeight: '12px',
  fontSize: '12px',
  fontWeight: 700,
  [theme.breakpoints.up('sm')]: {
    marginBottom: '20px'
  }
}));

export const ColumnLink = styled('div')(({ theme }: { theme?: Theme }) => ({
  marginBottom: '15px',
  display: 'block',
  fontSize: '12px',
  lineHeight: '12px',
  fontWeight: 300,
  transition: 'All 0.3s',
  '&:last-child': {
    marginBottom: 0
  },
  a: {
    textDecoration: 'none',
    color: '#09292f',
    fontWeight: 300,
    fontSize: '12px',
    '&:hover': {
      color: theme.palette.primary.main
    }
  },
  [theme.breakpoints.up('sm')]: {
    marginBottom: '20px'
  }
}));
